import { Layout } from "../components/Layout";
import { Breadcrumb } from "../components/Topbar";
import { PageHeader } from "../components/PageHeader";
import { EmptyState } from "../components/EmptyState";

export function PlaceholderPage({ title }: { title: string }) {
  return (
    <Layout breadcrumbs={<Breadcrumb items={[{ label: title }]} />}>
      <PageHeader title={title} subtitle="Em breve" />
      <EmptyState>Esta área será implementada em uma fase posterior.</EmptyState>
    </Layout>
  );
}
